import classNames from 'classnames'
import React, { type MouseEvent } from 'react'

import { useSurvey, useSurveySteps } from '../../module/survey/hook'
import Button from '../common/Button'
import Spinner from '../common/Spinner'

export default function ProcessButton({
  disabled,
  submitLoading,
  onNextClick,
}: {
  disabled?: boolean
  submitLoading?: boolean
  onNextClick?: (e?: MouseEvent<HTMLButtonElement>) => void
}) {
  const { surveyIsPending, surveyOnModal } = useSurvey()
  const { steps, activeStep, setNextStep } = useSurveySteps()

  // V2: 스텝 순서가 그룹과 무관하게 고정되어, 마지막 스텝에서만 submit
  const isNextButton = activeStep < steps.length - 1
  const isSubmitButton = activeStep === steps.length - 1

  const content = () => (
    <>
      {isNextButton &&
        (submitLoading ? (
          <>
            <span>진행중...</span>
            <div>
              <Spinner width={30} height={30} />
            </div>
          </>
        ) : (
          <span>다음</span>
        ))}
      {isSubmitButton &&
        (surveyIsPending ? (
          <>
            <span>진행중...</span>
            <div>
              <Spinner width={30} height={30} />
            </div>
          </>
        ) : (
          <span>완료</span>
        ))}
    </>
  )

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (onNextClick) {
      onNextClick(e)

      if (isNextButton) {
        setNextStep()
      }
    }
  }
  return (
    <div
      className={classNames(
        'bg-white sticky bottom-0 inset-x-0 px-[3px] mx-[-3px]' /* px, mx -> margin/padding for prevent showing radio-selected shodow behind */,
        surveyOnModal
          ? 'pt-[15px] pb-[30px]'
          : 'pt-[15px] pb-[25px] tablet-sm:pt-[25px] tablet-sm:pb-[25px] tablet-md:pt-[25px] tablet-md:pb-[50px] tablet-lg:pt-[25px] tablet-lg:pb-[80px]',
      )}
    >
      <Button
        disabled={disabled || submitLoading || surveyIsPending}
        form={isSubmitButton ? 'survey-form' : undefined}
        type={isNextButton ? 'button' : isSubmitButton ? 'submit' : undefined}
        onClick={handleClick}
      >
        {content()}
      </Button>
    </div>
  )
}
